import {
  ComponentRef,
  Directive,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewContainerRef,
} from '@angular/core';

import { setInputs } from '../../button.types';
import { ButtonNewComponent } from '../../components/button/button.comonent';
import { IconComponent } from './../../../icon/icon.component';

@Directive({
  selector: 'rt-button-new[dropdownOpened], a[rt-button-new][dropdownOpened]',
})
export class ButtonDropdownIndicatorDirective implements OnChanges, OnInit, OnDestroy {
  @Input() public dropdownOpened: boolean = false;
  @Input() public dropdownVisible: boolean = true;

  private vcRef: ViewContainerRef;
  private iconComponentRef: ComponentRef<IconComponent> | null;

  constructor(private button: ButtonNewComponent) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.dropdownOpened && this.iconComponentRef) {
      this.toggleDropdownOpened();
    }
    if (changes.dropdownVisible && this.iconComponentRef) {
      if (this.dropdownVisible) {
        this.button.addClass(['dropdown-indicator']);
        this.button.removeClass(['dropdown-indicator-hidden']);
      } else {
        this.button.removeClass(['dropdown-indicator']);
        this.button.addClass(['dropdown-indicator-hidden']);
      }
    }
  }

  public ngOnInit() {
    this.vcRef = this.button.secondarySlot;
    this.iconComponentRef = this.vcRef.createComponent(IconComponent);
    setInputs(this.iconComponentRef, {
      name: 'arrow-drop-down',
      size: 'small',
    });
    this.button.addClass(['dropdown-indicator']);
    if (this.dropdownVisible) this.button.addClass(['dropdown-indicator']);
    if (!this.dropdownVisible) this.button.addClass(['dropdown-indicator-hidden']);

    this.toggleDropdownOpened();
  }

  public ngOnDestroy() {
    if (this.iconComponentRef) {
      this.iconComponentRef.destroy();
    }
  }

  private toggleDropdownOpened(): void {
    this.dropdownOpened
      ? this.button.addClass(['dropdown-open', 'active'])
      : this.button.removeClass(['dropdown-open', 'active']);
  }
}
